<template>
  <div class="frame" :class="$mq">
    <h1>{{ $t(label("title")) }}</h1>
    <div class="addresses inline bottom">

      <div class="address" v-for="contract in possibleContracts" :key="contract.value">
        <SvgIcon :icon="contract.icon" class="icon" fill stroke/>
        <h2>{{ contract.delivery }}</h2>
        <CheckField
            :value="contract.value"
            icon="check"
            v-model="selected"
            round
            @change="feedModal(contract)"
            @checked="showModal($event)"
        ></CheckField>

      </div>
      <Modal
          class="modal"
          v-if="isShown"
          :title="$t('Comeback.ColdLoss.Modal.title')"
          :icon="modalContract.icon"
          :text="formatText(modalContract)"
          :confirm="$t('Comeback.ColdLoss.Modal.yes')"
          :cancel="$t('Comeback.ColdLoss.Modal.no')"
          :value="modalContract.value"
          @confirm="confirm()"
          @close="close($event)"
      ></Modal>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";
import Modal from "../../../components/Modal";
import CheckField from "../../../components/Form/SimulationFields/CheckField";

export default {
  name: "DeliveryPoints",
  data() {
    return {
      isShown: false,
      modalContract: {}
    }
  },
  computed: {
    ...mapState('comeback', ['contracts', 'selected', 'loss', 'type']),
    selected: {
      get() {
        return this.$store.state.comeback.selected;
      },
      set(value) {
        this.$store.commit("comeback/setSelected", value);
        this.$emit('disabled', this.selected.length === 0)
      },
    },
    possibleContracts() {
      return this.contracts.map(contract => {
        return {
          delivery: this.getDeliveryAddress(contract),
          ean: contract.ean,
          value: contract.id,
          icon: contract.energy === 'electricity' ? 'elec' : 'gas'
        }
      })
    },
  },
  methods: {
    label(value) {
      return "Comeback.DeliveryPoints." + value
    },
    getDeliveryAddress(contract) {
      return contract.delivery.street + ' ' + contract.delivery.number + ', ' + contract.delivery.postCode + ' ' + contract.delivery.town + '.';
    },
    feedModal(contract) {
      this.modalContract = contract
    },
    showModal(event) {
      this.isShown = ! event;
    },
    formatText(contract) {
      return `${this.$t('Comeback.ColdLoss.Modal.address')} <span style="font-weight: bold ;">${contract.delivery}</span><br>
        ${this.$t('Comeback.ColdLoss.Modal.ean')} <span style="font-weight: bold ;">${contract.ean}</span>`
    },
    confirm() {
      this.isShown = false;
    },
    close(event) {
      this.selected.push(event);
      this.$emit('disabled', this.selected.length === 0)
      this.isShown = false;
    }

  },
  created() {
  },
  components: {CheckField, Modal},
}
</script>

<style lang="scss">
.addresses {
  //flex-wrap: wrap;
  margin-bottom: 10px;
  justify-content: left;
  padding-left: 10px;


  .address {
    word-break: break-word;
    display: flex;
    align-items: center;
    text-align: left;
    //width: 120px;
    //min-width: 100px;

    h2 {
      font-size: .8rem;
      margin: 10px;
      max-width: 75%;
    }

    .checkbox .check-button {
      margin: 0 !important;
    }

    .icon {
      margin: 0 10px 0 0;
      font-size: 1.5rem;
      color: #fdcb47;
    }

  }
}

</style>



// WEBPACK FOOTER //
// src/views/Comeback/ColdLoss/DeliveryPoints.vue